import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/propertymanagement.css";

function PropertyManagement() {
  const navigate = useNavigate();

  // State for properties list
  const [properties, setProperties] = useState([
    { id: 1, name: "A-101", type: "Apartment", owner: "Sparsh", status: "Occupied" },
    { id: 2, name: "B-202", type: "Apartment", owner: "Nikhil", status: "Vacant" },
    { id: 3, name: "C-303", type: "Villa", owner: "Hunney", status: "Occupied" }
  ]);

  // State for form inputs
  const [newProperty, setNewProperty] = useState({
    name: "",
    type: "Apartment",
    owner: "",
    status: "Vacant"
  });

  // Function to handle form input changes
  const handleInputChange = (e) => {
    setNewProperty({ ...newProperty, [e.target.name]: e.target.value });
  };

  // Function to add a new property
  const handleAddProperty = () => {
    if (!newProperty.name || !newProperty.owner) {
      alert("Please fill in all fields!");
      return;
    }

    const updatedProperties = [
      ...properties,
      { id: properties.length + 1, ...newProperty }
    ];

    setProperties(updatedProperties);
    setNewProperty({ name: "", type: "Apartment", owner: "", status: "Vacant" });
  };

  return (
    <div className="property-management-wrapper">
      {/* Full-Width Sticky Navbar */}
      <nav className="property-navbar">
        <div className="property-navbar-content">
          <span className="property-title">Manage Properties</span>
          {/* <button className="back-btn" onClick={() => navigate("/")}>Back</button> */}
        </div>
      </nav>

      {/* Property List Container */}
      <div className="property-container">
        {/* <h2 className="property-heading">Manage Properties</h2> */}

        {/* Property Form */}
        <div className="property-form">
          <input
            type="text"
            name="name"
            placeholder="Property Name (e.g., A-101)"
            value={newProperty.name}
            onChange={handleInputChange}
          />
          <select name="type" value={newProperty.type} onChange={handleInputChange}>
            <option value="Apartment">Apartment</option>
            <option value="Villa">Villa</option>
            <option value="Penthouse">Penthouse</option>
          </select>
          <input
            type="text"
            name="owner"
            placeholder="Owner Name"
            value={newProperty.owner}
            onChange={handleInputChange}
          />
          <select name="status" value={newProperty.status} onChange={handleInputChange}>
            <option value="Occupied">Occupied</option>
            <option value="Vacant">Vacant</option>
          </select>
          <button className="add-property-btn" onClick={handleAddProperty}>
            + Add Property
          </button>
        </div>

        {/* Property Table */}
        <div className="property-table-wrapper">
          <table className="property-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Property Name</th>
                <th>Type</th>
                <th>Owner</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {properties.length === 0 ? (
                <tr><td colSpan="5">No properties available</td></tr>
              ) : (
                properties.map((property) => (
                  <tr key={property.id}>
                    <td>{property.id}</td>
                    <td>{property.name}</td>
                    <td>{property.type}</td>
                    <td>{property.owner}</td>
                    <td>{property.status}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <footer className="admin-dashboard-footer">
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/admin")}>
          Home
        </button>
        
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/resident")}>
          Resident
        </button>
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/adminreport")}>
          Reports
        </button>
      </footer>
    </div>
  );
}

export default PropertyManagement;
